var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "package-products") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-2405.000000, -105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "package-products",
    transform: "translate(2405.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 243,
    cy: 237,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Box_8_line_02",
    transform: "translate(100.000000, 102.000000)",
    stroke: "#000000",
    strokeWidth: 17.699115
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.035398,177.142857 C296.300885,177.142857 299.867257,180.163143 300.699115,184.184286 L344.938053,396.729143 C345.070796,397.322571 345.132743,397.942571 345.132743,398.571429 C345.132743,402.326857 342.79646,405.542 339.486726,406.826286 L180.19469,468.826286 C179.20354,469.216 178.123894,469.428571 176.99115,469.428571 C176.575221,469.428571 176.159292,469.402 175.752212,469.34 L51.7876106,451.616857 C48.3097345,451.103143 45.4867257,448.561143 44.5663717,445.230857 L0.336283186,285.855429 C0.115044248,285.084857 0,284.27 0,283.428571 C0,280.984 0.991150442,278.769714 2.59292035,277.166571 L99.9380531,179.738 C101.539823,178.134857 103.752212,177.142857 106.19469,177.142857 L292.035398,177.142857 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.19469,
    y1: 177.142857,
    x2: 176.99115,
    y2: 469.428571,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.265487,
    y1: 382.114857,
    x2: 196.00885,
    y2: 397.570571,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.486726,
    y1: 275.678571,
    x2: 187.442478,
    y2: 362.186286,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "31.2831858 248.442857 51.3362832 320.699429 88.2920354 310 65.1681416 214.528857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.088496,177.134 L212.672566,24.3394286 C213.584071,20.8231429 216.59292,18.166 220.283186,17.7674286 L388.477876,0.0442857143 C388.769912,0.0177142857 389.070796,0 389.380531,0 C391.973451,0 394.309735,1.116 395.929204,2.90514286 L484.424779,100.333714 C485.858407,101.901429 486.725664,103.991714 486.725664,106.285714 C486.725664,107.268857 486.566372,108.207714 486.274336,109.084571 L433.176991,268.513143 C432.00885,272.038286 428.690265,274.571429 424.778761,274.571429 L319.557522,274.571429",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.380531,
    y1: 89.4571429,
    x2: 219.265487,
    y2: 140.066857,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.575221,
    y1: 53.94,
    x2: 237.575221,
    y2: 69.378,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.380531,
    y1: 0,
    x2: 310.982301,
    y2: 233.598286,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "429.212389 39.5382857 400.867257 124 440.00885 141.714286 462.00885 75.6488571"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.380531,
    y1: 496,
    x2: 389.380531,
    y2: 434,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.477876,
    y1: 425.142857,
    x2: 442.477876,
    y2: 407.428571,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.477876,
    y1: 389.714286,
    x2: 442.477876,
    y2: 327.714286,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.575221,
    y1: 212.571429,
    x2: 495.575221,
    y2: 230.285714,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.575221,
    y1: 248,
    x2: 495.575221,
    y2: 301.142857,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5486726,
    y1: 186,
    x2: 26.5486726,
    y2: 168.285714,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5486726,
    y1: 150.571429,
    x2: 26.5486726,
    y2: 79.7142857,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3451327,
    y1: 8.85714286,
    x2: 97.3451327,
    y2: 79.7142857,
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.82c3b132f82c437b329ccaf69d62e83c.svg";
export { ForwardRef as ReactComponent };